import styled from 'styled-components';
import { ReactComponent as RawNotificationBellSVG } from '../../../../assets/icons/icon_notification.svg';

export const IconNotificationBell = styled(RawNotificationBellSVG)``;
